// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip-module--Tooltip--mknyF",":popover-open":"Tooltip-module--:popover-open--8BJlh","tooltip-appear":"Tooltip-module--tooltip-appear--pS-SH"};